import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ToolTip = ({ text, icon, id }) => {
  return (
    <span className="form-tooltip">
      <span data-tooltip-content={text} data-tooltip-id={id} data-delay-show={100} className="ct-tooltip-button">
        <FontAwesomeIcon icon={icon} />
      </span>
      <ReactTooltip
        id={id}
        place="top"
        effect="float"
        type="dark"
        className={'form-tooltip__bubble'}
        clickable={true}
      />
    </span>
  );
};
